import React, { Component } from "react"

export default class BABAABP extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">BABAABP</p>
            <p className="portdesctext">"Between a Bird and a Bad Place" is a short film made in collaboration with Lila Bullen-Smith for <a href = "https://www.badvideoart.com/v-selections-2021" target="_blank" rel="noopener noreferrer">Bad Video Art Festival 2021</a>. Footage and audio recorded by us using tape, digital, & laptop camera, edited in Photoshop, and composed remotely. Abstract <a href = "https://www.dropbox.com/s/dr9qwjof58sbk9r/Between%20a%20Bird%20and%20a%20Bad%20Place%20%28publish%29.pdf?dl=0" target="_blank" rel="noopener noreferrer">here</a> and video is in link below.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.dropbox.com/s/nm167qove3nhuve/bad_vid_final_4%20%28dropbox%29.mov?dl=0" target="_blank" rel="noopener noreferrer"><p className="linktext">Video</p></a>
        </div>
      </div>
  )
}
}

